(function () {
  'use strict';

  angular.module('clientDashboardApp.admin.updates.updateService',[]).service('updateService', ['cacheService','adminSearchService',UpdateService]);

  function UpdateService(cacheService, adminSearchService){

    this.cs_ = cacheService;
    this.ss_ = adminSearchService;

    this.states = {
      active : "Active",
      inactive : "Inactive"
    }

    this.defaultUpdateStatus = {
      status: this.states.inactive,
      type: null,
      title: null,
      mode: null,
      id: null,
      name: null,
      searchParam: null
    }

    this.update = this.defaultUpdateStatus;
    this.requestParam = null;

  }

  UpdateService.prototype.generateRequestParam = function(){
    if(this.update.type=='userLocation'){
      this.requestParam = this.update.name;
    }
    else if(this.update.type=='userGroup' || this.update.type=='groupLocation'){
      this.requestParam = this.update.id;
    }
  }

  UpdateService.prototype.registerSuccessfulUpdate = function(updateInfo,skipRefresh){
    this.update = updateInfo;
    this.generateRequestParam();
    if(!skipRefresh){
      this.cs_.refreshCache(this.update.type);
    }
  }

  UpdateService.prototype.resetUpdateStatus = function(){
    this.update = this.defaultUpdateStatus;
  }

  UpdateService.prototype.getUpdateDetails = function(){
    return this.update;
  }


})();
